import { Link } from 'react-router-dom';
import { setLocale, t, useLocale } from '../lib/i18n.js';

export function SiteHeader() {
  const locale = useLocale();
  return (
    <header className="site-header">
      <Link className="brand" to="/" aria-label="Listen & Draw home">
        <span className="brand-mark" aria-hidden="true">
          L<span>↗</span>
        </span>
        Listen <span className="brand-amp">&</span> Draw
      </Link>
      <nav aria-label={t('Main navigation', 'メインナビゲーション')}>
        <Link to="/daily" className="nav-daily">
          {t('Daily challenge', '今日の一問')}
        </Link>
        <Link to="/help">{t('How to play', '遊び方')}</Link>
        <button
          className="language-switch"
          aria-label={t('Switch to Japanese', 'Switch to English')}
          onClick={() => setLocale(locale === 'en' ? 'ja' : 'en')}
        >
          {locale === 'en' ? '日本語' : 'EN'}
        </button>
      </nav>
    </header>
  );
}
